module.exports = "/_next/static/images/ar-6a2c66703e9c3dc3b148b37a8a4b730f.svg";